let video = document.querySelectorAll('.video');

// Get Youtube thumbnailUrl by video-link
const Youtube = (url, size) => {
    let video, results;
    
    if (url === null) {
        return '';
    }
    size = (size === null) ? 'big' : size;
    results = url.match('[\\/&]embed/([^&#]*)');
    video = (results === null) ? url : results[1];
    
    if (size === 'small') {
        return 'https://img.youtube.com/vi/' + video + '/1.jpg';
    }
    return 'https://img.youtube.com/vi/' + video + '/hqdefault.jpg';
};

function YouTubeGetID(url){
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

if (video.length) {
    [].forEach.call(video, (el) => {
        let placeholder = el.querySelector('.video__placeholder');
        let placeholderLink = placeholder.querySelector('.video__placeholder__trigger');
        let playButton = placeholderLink.querySelector('button');
        
        // Check if clicked element has a video url in the dataset
        let videoLink = el.dataset.video;
        if (videoLink) {
            let videoId = YouTubeGetID(videoLink);
            videoLink = `https://www.youtube.com/embed/${videoId}`;
            // Add playButton when there's no videoLink available
            playButton.classList.add('active');
            
            placeholderLink.addEventListener('click', () => {
                
                // Remove play button on click
                playButton.classList.remove('active');
                
                // Create iframe
                let iframe = document.createElement('div');
                let autoPlay = '1';
                iframe.innerHTML = '<iframe src="' + videoLink + '?rel=0&autoplay=' + autoPlay + '&enablejsapi=1" class="youtube-video" frameborder="0" allow="autoplay; encrypted-media gyroscope; picture-in-picture" allowfullscreen></iframe>';
                
                // Replace the anchor with the video
                placeholder.replaceChild(iframe, placeholderLink);
                placeholder.classList.add('video__placeholder--video-added');
            });
        }
        
        if (!el.querySelector('img')) {
            const img = document.createElement("img");
            img.src = Youtube(`${videoLink}`, 'big');
            
            el.querySelector('.video__placeholder__trigger').insertBefore(
              img,
              el.querySelector('.video__content')
            );
        }
    });
}